<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content" @before-close="closeDialog" :click-to-close="!tourStatus">
    <div class="modal-header justify-content-end">
      <div>
        <button type="button" class="btn-close" aria-label="Close" @click="closeDialog()"></button>
      </div>
    </div>

    <div class="modal__body">

      <div class="row col-12 p-1" id="confirm-allow-list">
        <p class="text-default vertical-align" style="font-weight: 900; font-size: 14px; margin: 0;">Please add the following domains and IPs to your organisation's email allow list.</p>
        <table class="table">
          <thead>
            <tr class="table-light text-default">
              <th>Name</th>
              <th>IP Address</th>
            </tr>
          </thead>
            <tbody class="align-middle text-default">
              <tr v-for="(item, index) in domains" :key="index">
                  <td>
                      {{ item.name }}
                      <button @click="copyToClipboard(item.name)" class="btn btn-link copy-button">
                          <i class="fas fa-copy" style="color: #435666;"></i>
                      </button>
                  </td>
                  <td>
                      {{ item.ip_address }}
                      <button @click="copyToClipboard(item.ip_address)" class="btn btn-link copy-button">
                          <i class="fas fa-copy" style="color: #435666;"></i>
                      </button>
                  </td>
              </tr>
            </tbody>
          </table>
        </div>


        <div>
          <p class="text-default p-0 mb-0" style="font-weight: 900; font-size: 14px;">Need Help?</p>
          <p class="text-default p-0 mb-0" style="font-weight: 900; font-size: 13px; font-style: italic;">Click the links below.</p>


    <ul class="list-unstyled" style="font-size: 14px;">
      <li>
        <a :href="pdfPath('Phishing Simulation Setup Guide for Google Workspace.pdf')" target="_blank" class="text-decoration-none text-info">
          Google Workspace
        </a>
      </li>
      <li>
        <a :href="pdfPath('Phishing Simulation Setup Guide for Office 365.pdf')" target="_blank" class="text-decoration-none text-info">
          Office 365
        </a>
      </li>
      <li>
        <a :href="pdfPath('Phishing Simulation Setup Guide for Sophos.pdf')" target="_blank" class="text-decoration-none text-info">
          Sophos
        </a>
      </li>
    </ul>

        </div>

        <div class="col-12">
            <p class="text-default p-0 mb-0 text-center" style="font-weight: 900; font-size: 14px;">Confirm allow list changes complete.</p>
            <div class="arrow-container text-center mt-4">
              <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001" xml:space="preserve"><path style="fill:#298983" d="m256 340.318 45.387-45.387v-32.427h-90.775v32.426z"/><path style="fill:#62d9c7" d="M210.614 139.135h90.778v55.718h-90.778z"/><path d="M202.322 211.434h107.354a8.29 8.29 0 0 0 8.29-8.29v-72.296a8.29 8.29 0 0 0-8.29-8.29H202.322a8.29 8.29 0 0 0-8.29 8.29v72.296a8.29 8.29 0 0 0 8.29 8.29zm8.29-72.296h90.775v55.717h-90.775v-55.717z"/><path style="fill:#298983" d="M210.614 16.579h90.778v55.718h-90.778z"/><path d="M202.322 88.876h107.354a8.29 8.29 0 0 0 8.29-8.29V8.29a8.29 8.29 0 0 0-8.29-8.29H202.322a8.29 8.29 0 0 0-8.29 8.29v72.296a8.291 8.291 0 0 0 8.29 8.29zm8.29-72.297h90.775v55.717h-90.775V16.579z"/><path transform="rotate(45.001 343.061 340.897)" style="fill:#a5f2e5" d="M297.667 279.75h90.777v122.3h-90.777z"/><path d="m435.977 323.887-75.911-75.911a8.289 8.289 0 0 0-11.724 0l-30.375 30.375v-24.137a8.29 8.29 0 0 0-8.29-8.29H202.322a8.29 8.29 0 0 0-8.29 8.29v24.136l-30.374-30.374a8.291 8.291 0 0 0-11.724 0l-75.912 75.911a8.29 8.29 0 0 0 0 11.722l42.453 42.452a8.29 8.29 0 0 0 11.724-11.723l-36.592-36.591 64.188-64.188L320.034 427.8l-64.187 64.188-83.643-83.643a8.29 8.29 0 0 0-11.724 11.723l89.506 89.506a8.29 8.29 0 0 0 5.863 2.428c.051 0 .102-.007.153-.008.051.001.102.008.153.008a8.292 8.292 0 0 0 5.862-2.428L435.98 335.612a8.295 8.295 0 0 0-.003-11.725zm-104.066 92.341-64.187-64.188 86.481-86.48 64.187 64.188-86.481 86.48zm-30.524-153.724v32.427L256 340.318l-45.388-45.388v-32.426h90.775z"/><path style="fill:#62d9c7" d="m172.204 408.343 83.643 83.643 64.187-64.188-162.237-162.237-64.188 64.188 36.592 36.591a8.29 8.29 0 0 1 0 11.723l30.28 30.28a8.292 8.292 0 0 1 11.723 0z"/></svg>
            </div>
        </div>

        <div class="modal__input-fields mt-4">
          <div class="col-12">
            <div class="text-center p-1">
              <button type="button" class="btn btn-outline-primary-inverse" @click="confirm">Confirm</button>
            </div>
          </div>
        </div>
    </div>

  </vue-final-modal>
 </template>

 <script>
import googleWorkspacePDF from '@/assets/pdf/Phishing Simulation Setup Guide for Google Workspace.pdf';
import office365PDF from '@/assets/pdf/Phishing Simulation Setup Guide for Office 365.pdf';
import sophosPDF from '@/assets/pdf/Phishing Simulation Setup Guide for Sophos.pdf';

 export default {
  name: "Frequency",

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    onboarding: {
      type: Object,
      required: false
    },
    tourStatus: {
      type: Boolean,
      required: false,
    },
  },

   data() {
     return {
       state: true,
       confirmed: true,
       domains: null,
       orgID: this.$helper.setOrganisationID(),
     };
   },

  async mounted() {
    await this.getData();
  },

   methods: {

    pdfPath(filename) {
      switch (filename) {
        case 'Phishing Simulation Setup Guide for Google Workspace.pdf':
          return googleWorkspacePDF;
        case 'Phishing Simulation Setup Guide for Office 365.pdf':
          return office365PDF;
        case 'Phishing Simulation Setup Guide for Sophos.pdf':
          return sophosPDF;
        default:
          return ''; // Handle other cases or errors
      }
    },

    async getData() {
      await this.$axios.get('/orgadmin/phishing-domain/' + this.orgID)
      .then((response) => {
          if (response.data.success){
            this.domains = response.data.domains;
          } else {
            this.$toast.error(response.data.message)
          }
        this.loading = false;
      })
      .catch()
    },

    copyToClipboard(text) {
        const tempInput = document.createElement('input');
        tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
        tempInput.value = text;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        this.$toast.success("Copied " + text + " to clipboard.");
    },

    confirm(){
      this.$emit('confirm', this.confirmed);
      if (this.tourStatus) {
        this.onboarding.goToStep(3)
      }
      this.state = false;
    },

     closeDialog() {
      this.$emit("close");
      this.state = false;
      },
   },

   watch: {
     value(newVal) {
       const range = this.maxDays - this.minDays;
       const percent = (newVal - this.minDays) / range;
       this.dotLeft = this.lineWidth * percent - 5;
       this.selectedDays = newVal;
     }
   }
 };
 </script>

<style scoped>
:deep(.modal-content) {
  background: linear-gradient(to bottom, #00A0C1 55px, white 20px);
  width: 644px !important;
  overflow-y: auto;
}

.arrow-container {
    animation: bounce 1s infinite;
}

@keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-10px);
    }
    60% {
        transform: translateY(-5px);
    }
}
</style>
